import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  // 當身份驗證狀態正在加載時顯示加載狀態
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-danger" role="status">
          <span className="visually-hidden">加載中...</span>
        </div>
      </div>
    );
  }
  
  // 如果用戶未登錄，重定向到登錄頁面
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 如果有子元素，則渲染子元素，否則渲染Outlet
  return children ? children : <Outlet />;
};

export default ProtectedRoute;